var _path, _path2, _circle, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoRedeem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5808 10.6035C18.5808 14.846 15.1416 18.2852 10.8991 18.2852C6.65653 18.2852 3.21729 14.846 3.21729 10.6035C3.21729 6.36094 6.65653 2.92169 10.8991 2.92169C15.1416 2.92169 18.5808 6.36094 18.5808 10.6035Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8991 18.3307C15.1667 18.3307 18.6263 14.8711 18.6263 10.6035C18.6263 6.33588 15.1667 2.87628 10.8991 2.87628C6.63147 2.87628 3.17188 6.33588 3.17188 10.6035C3.17188 14.8711 6.63147 18.3307 10.8991 18.3307Z",
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.8992,
    cy: 10.6034,
    r: 8.33328,
    fill: "#3274F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8992 18.9367C9.25104 18.9367 7.63988 18.448 6.26948 17.5323C4.89908 16.6166 3.83098 15.3151 3.20025 13.7924C2.56953 12.2697 2.4045 10.5942 2.72604 8.97768C3.04758 7.36118 3.84125 5.87634 5.00668 4.71091C6.17211 3.54548 7.65696 2.75181 9.27346 2.43027C10.89 2.10873 12.5655 2.27375 14.0882 2.90448C15.6109 3.5352 16.9124 4.6033 17.8281 5.9737C18.7437 7.3441 19.2325 8.95526 19.2325 10.6034C19.23 12.8128 18.3513 14.931 16.789 16.4932C15.2268 18.0555 13.1086 18.9343 10.8992 18.9367ZM6.2409 9.42843L5.06591 10.6034L9.23255 14.7701L16.7325 7.27011L15.5575 6.08679L9.23255 12.4117L6.2409 9.42843Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRedeem);
export default __webpack_public_path__ + "static/media/icoRedeem.419ba1c0bff85841c5d515108697b104.svg";
export { ForwardRef as ReactComponent };